/**
 * IMPORTS
 */

import { extendTheme } from '@chakra-ui/react';

/**
 * CORE
 */

// @see https://smart-swatch.netlify.app/ (get JS object)
const colors = {
  brand: {
    50: '#0f7ef5',
    100: '#0972e1',
    200: '#0865c9',
    300: '#0759b0',
    400: '#064d98',
    500: '#054080',
    600: '#043467',
    700: '#03284f',
    800: '#021b36',
    900: '#010f1e',
  },
  snapchat: {
    50: "#403F00",
    100: "#666500",
    200: "#8C8B00",
    300: "#B3B000",
    400: "#D9D600",
    500: "#FFFC0D",
    600: "#FFFD33",
    700: "#FFFD59",
    800: "#FFFE80",
    900: "#FFFEA6"
  },
  tiktok: {
    50: "#000000",
    100: "#000000",
    200: "#000000",
    300: "#000000",
    400: "#000000",
    500: "#000000",
    600: "#262626",
    700: "#404040",
    800: "#595959",
    900: "#737373"
  },
};

const fonts = {
  body: '"Open Sans",Arial,sans-serif',
  heading: 'Oswald,Helvetica,Arial,sans-serif',
};

const Button = {
  baseStyle: {
    borderRadius: 'full',
  },
};

const Heading = {
  baseStyle: {
    color: 'brand.500',
    textTransform: 'uppercase',
  },
};

const theme = extendTheme({
  colors,
  fonts,
  components: {
    Button,
    Heading,
  },
});

export default theme;
